import { Button, styled } from "@mui/material";

export const ContainedButton = styled(Button)<{
  backgroundColor?: String;
  textColor?: string;
}>((theme: any) => ({
  backgroundColor: "#43425D",
  borderRadius: "5px",
  color: "#ffff",
  fontSize: "12px",
  fontFamily: "Poppins",
  textTransform: "none",
  marginRight: "5px",
  "&:hover": {
    backgroundColor: "#43425D",
  },
  "&:disable": {
    backgroundColor: "#43425D",
  },
}));

export const OutlinedButton = styled(Button)<{
  backgroundColor?: String;
  textColor?: string;
}>((theme: any) => ({
  borderRadius: "5px",
  borderColor: theme.backgroundColor,
  color: "#43425D",
  fontSize: "12px",
  fontFamily: "Poppins",
  textTransform: "none",
  marginRight: "5px",
  "&:hover": {
    borderColor: theme.textColor || theme.backgroundColor,
    backdropClasses: "#ffff"
  },
}));